import type { FaqModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function FaqModule({ eyebrow, heading, items }: FaqModuleProps) {
  return (
    <section className="cms-section cms-faq" data-cms-module="faq">
      <div className="cms-wrap">
        <div className="cms-faq__layout">
          <div className="cms-faq__intro">
            <div className="cms-eyebrow-row">
              <span className="cms-eyebrow">
                {renderTextWithLineBreaks(eyebrow || "Questions")}
              </span>
            </div>
            {heading ? <h2>{renderTextWithLineBreaks(heading)}</h2> : null}
          </div>
          <div className="cms-faq__list">
            {items.map((item, index) => (
              // Native accordion: `name` makes the items mutually exclusive
              // (one open at a time) without any client-side JavaScript.
              <details
                className="cms-faq__item"
                key={item.question || index}
                name="cms-faq"
              >
                <summary className="cms-faq__question">
                  <span>{renderTextWithLineBreaks(item.question)}</span>
                  <span className="cms-faq__marker" aria-hidden="true" />
                </summary>
                <div className="cms-faq__answer">
                  <p>{renderTextWithLineBreaks(item.answer)}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
